import React from 'react'

export default class IconsAlignBottom extends React.Component {
    render() {
        let color = '#C8C5FE'
        if (this.props.color) color = this.props.color
        return (
            <svg
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                style={this.props.style}
            >
                <g>
                    <path
                        d='M5.33268 1.33337H3.99935C3.26297 1.33337 2.66602 1.93033 2.66602 2.66671V10.6667C2.66602 11.4031 3.26297 12 3.99935 12H5.33268C6.06906 12 6.66602 11.4031 6.66602 10.6667V2.66671C6.66602 1.93033 6.06906 1.33337 5.33268 1.33337Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M12.0007 6H10.6673C9.93094 6 9.33398 6.59695 9.33398 7.33333V10.6667C9.33398 11.403 9.93094 12 10.6673 12H12.0007C12.737 12 13.334 11.403 13.334 10.6667V7.33333C13.334 6.59695 12.737 6 12.0007 6Z'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                    <path
                        d='M14.6673 14.6666H1.33398'
                        stroke={color}
                        strokeWidth='1.25'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                    />
                </g>
            </svg>
        )
    }
}
